var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isGd == 'true'|| _vm.isYLZ == 'true')?_c('GdAddDevice',{attrs:{"apiHost":_vm.apiHost}}):_vm._e(),(_vm.isGd != 'true'&& _vm.isYLZ != 'true' && _vm.isCP != 'true')?_c('AddDevice'):_vm._e(),(_vm.isCP == 'true')?_c('CPAddDevice',{attrs:{"apiHost":_vm.apiHost}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }